var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[_c('div',{staticClass:"details_model",domProps:{"innerHTML":_vm._s(_vm.datas)}},[_vm._v(" "+_vm._s(_vm.datas)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }